import { useSnackbar } from 'notistack';

import {
  Box,
  Grid,
  MenuItem
} from '@mui/material';

import { useTranslate } from 'src/locales';
import { useGetTypeDefinitionsQuery } from 'src/services/system/system.service';

import { RHFSelect } from 'src/components/hook-form/rhf-select';

export default function WorkRightsEditor() {

  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const { data: typeDefinitionData } = useGetTypeDefinitionsQuery();

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Box sx={{ mb: 3 }}>
          <RHFSelect
            fullWidth
            name="work_rights"
            label={t('enums.work_rights.input_label')}
          >
            <MenuItem key="default" value="">
              {t('common.none')}
            </MenuItem>
            {typeDefinitionData
              ? typeDefinitionData.WorkRightType.map((rightsType: string) => (
                <MenuItem key={rightsType} value={rightsType}>
                  {t(`enums.work_rights.${rightsType}`)}
                </MenuItem>
              ))
              : null}
          </RHFSelect>
        </Box>
      </Grid>
    </Grid>
  );
}